(function($, undefined) {
	'use strict';

	var init = function() {
		$('.change-coaching-status-btn').on('click', onChangeCoachingStatusBtnClick);
		$('.change-coach-btn').on('click', onChangeCoachBtnClick);
		$('.toggle-coach-available-status').change(changeCoachAvailability);
	};

	var onChangeCoachingStatusBtnClick = function() {
		var btn = $(this);
		var popup = btn.closest('.stool-shared-popup-inner');
		var popupOuter = popup.closest('.stool-shared-popup');
		var paymentId = btn.attr("data-id");
		var checkedInput = $('input.coaching-status:checked', popup);
		var coachingStatus = checkedInput.val();
		var textCtn = $('.table__context[data-id=' + paymentId + "]").find('.coaching-status-text');

		if (coachingStatus == "on") { coachingStatus = ""; }

		var url = '/action/pmiPayment';
		var data = {
			ajax: true,
			paymentDetailId: paymentId,
			status: coachingStatus
		};

		popup.addClass("has-processing_active");
		$.ajax({
			url: url,
			method: "post",
			data: data,
			cache: false,
			complete: function(response) {
				popup.removeClass("has-processing_active");
				if (response.responseText.indexOf('success') !== -1) {
					textCtn.html(checkedInput.closest('label').find('span.input-checkbox__label p').html());
					textCtn.removeClass("pill_color_orange pill_color_violet pill_color_aqua");
					textCtn.addClass(getCoachingStatusPillColorClass(coachingStatus));
					closePopup(popupOuter);
				}
			}
		});
	};

	var onChangeCoachBtnClick = function() {
		var btn = $(this);
		var popup = btn.closest('.stool-shared-popup-inner');
		var popupOuter = popup.closest('.stool-shared-popup');
		var paymentId = btn.attr("data-id");
		var checkedInput = $('input.coach-id:checked', popup);
		var coachId = checkedInput.val();
		var coachNameText = $('.table__context[data-id=' + paymentId + "]").find('.coach-name');

		var url = '/action/pmiPayment';
		var data = {
			ajax: true,
			paymentDetailId: paymentId,
			coachId: coachId
		};

		popup.addClass("has-processing_active");
		$.ajax({
			url: url,
			method: "post",
			data: data,
			cache: false,
			complete: function(response) {
				popup.removeClass("has-processing_active");
				if (response.responseText.indexOf('success') !== -1) {
					coachNameText.html(checkedInput.closest('label').find('span.input-checkbox__label p').html());
					closePopup(popupOuter);
				}
			}
		});
	};

	var getCoachingStatusPillColorClass = function(status) {
		var pillClass = "pill_color_";

		switch (status) {
			case "true": pillClass += "violet"; break;
			case "false": pillClass += "aqua"; break;
			default: pillClass += "orange";
		}

		return pillClass;
	};

	var closePopup = function(popup) {
		if (!popup.hasClass("keep-scroll")) {
			$('body').removeClass('no-scroll');
			$('body').css('padding-right', '0px');
		}
		popup.removeClass('no-anim').removeClass('visible');
	};

	var changeCoachAvailability = function() {
		var t = $(this);
		var ctn = t.closest('.my-coaching-status-toggle-outer-ctn');
		var val = ctn.find('.toggle-coach-available-status:checked').val();
		var emails = ctn.find('input[name=admin-email]').val().split(',');

		ctn.find('form').find('input[name="isAvailable"]').val(val);

		if (val === 'false') {
			emails.forEach(function(el) {
				var url = '/action/sendEmail';
				url += '?email=' + encodeURIComponent(el);
				url += '&subject=' + encodeURIComponent(ctn.find('input[name=subject]').val());
				url += '&fullName=' + encodeURIComponent(ctn.find('input[name=person-name]').val());
				url += '&file=coach-unavailable-' + ctn.find('input[name=lang]').val();
				url += '&personId=0';
				var obj = ajax(url);
			});
		}

		ctn.find('form').submit();
	};

	$(window).ready(function() {
		init();
	});
})(jQuery);
